import React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
// import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Grid from '@mui/material/Grid';
// import Avatar from '@mui/material/Avatar';
// import BlogArticle from 'views/BlogArticle';
import { Link } from 'react-router-dom';
import { assets } from 'assets/assets';
const mock = [
  {
    image: assets.blogSection.story1,
    description:
      'Imagine learning and fun in one fine mix? We wanted it and we did it. Surrounded by food, fine dining,games and of courses our resource persons we created a memory that would linger in the hearts of our attendees for a very long time  ',
    title: 'Tech N chills',
    to: `/blog/1`,

    date: '05 Sept',
  },
  {
    image: assets.blogSection.story2,
    description:
      'Getting into the tech space just got easier. Everything you must have heard about how tough it is to break into the techspace got de-mystified into one powerful session, right in our hub',
    title: 'Zero to Hero Seminar',
    to: `/blog/2`,
    date: '15 March',
  },
  // {
  //   image:
  //     'https://firebasestorage.googleapis.com/v0/b/topibro-tech.appspot.com/o/minified-images%2Fseminar-event-home-topibro.jpg?alt=media&token=160dc032-6a40-4087-a560-26ed75340dbe',
  //   description:
  //     'Qui blanditiis praesentium voluptatum deleniti atque corrupti',
  //   title: 'Unde omnis iste natus',
  //   author: {
  //     name: 'Read More',
  //     avatar: 'https://assets.maccarianagency.com/avatars/img3.jpg',
  //   },
  //   date: '05 Mar',
  // },
];

const LastStories = () => {
  const theme = useTheme();
  return (
    <Box>
      <Box
        display={'flex'}
        justifyContent={'space-between'}
        alignItems={{ xs: 'flex-start', sm: 'center' }}
        flexDirection={{ xs: 'column', sm: 'row' }}
        marginBottom={4}
      >
        <Box>
          <Typography fontWeight={700} variant={'h6'} gutterBottom>
            Latest stories
          </Typography>
          <Typography color={'text.secondary'}>
            Here’s what we’ve been up to recently.
          </Typography>
        </Box>
        {/* <Box display="flex" marginTop={{ xs: 2, md: 0 }}>
          <Box
            component={Button}
            variant="outlined"
            color="primary"
            size="large"
            marginLeft={2}
          >
            View all
          </Box>
        </Box> */}
      </Box>
      <Grid container spacing={4}>
        {mock.map((item, i) => (
          <Grid item xs={12} sm={6} md={6} key={i}>
            <Box
              component={'a'}
              href={item.to}
              display={'block'}
              width={1}
              height={1}
              sx={{
                textDecoration: 'none',
                transition: 'all .2s ease-in-out',
                '&:hover': {
                  transform: `translateY(-${theme.spacing(1 / 2)})`,
                },
              }}
            >
              <Box
                component={Card}
                width={1}
                height={1}
                boxShadow={4}
                display={'flex'}
                flexDirection={'column'}
                sx={{ backgroundImage: 'none' }}
              >
                <CardMedia
                  image={item.image}
                  title={item.title}
                  sx={{
                    height: { xs: 300, md: 400 },
                    position: 'relative',
                  }}
                >
                  <Box
                    component={'svg'}
                    viewBox="0 0 2880 480"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    sx={{
                      position: 'absolute',
                      bottom: 0,
                      color: theme.palette.background.paper,
                      transform: 'scale(2)',
                      height: 'auto',
                      width: 1,
                      transformOrigin: 'top center',
                    }}
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M2160 0C1440 240 720 240 720 240H0v240h2880V0h-720z"
                      fill="currentColor"
                    />
                  </Box>
                </CardMedia>
                <Box component={CardContent} position={'relative'}>
                  <Typography variant={'h6'} gutterBottom>
                    {item.title}
                  </Typography>
                  <Typography color="text.secondary">
                    {item.description}
                  </Typography>
                </Box>
                <Box flexGrow={1} />
                <Box padding={2} display={'flex'} flexDirection={'column'}>
                  <Box marginBottom={2}>
                    <Divider />
                  </Box>
                  <Box
                    display={'flex'}
                    justifyContent={'space-between'}
                    alignItems={'center'}
                  >
                    <Box display={'flex'} alignItems={'center'}>
                      {/* <Avatar
                        src={item.author.avatar}
                        sx={{ marginRight: 1 }}
                      /> */}
                      <Typography color={'text.secondary'}>
                        <Link
                          to={item.to}
                          style={{
                            textDecoration: 'none',
                            color: '#016D5B',
                          }}
                        >
                          Read More
                        </Link>
                      </Typography>
                    </Box>
                    <Typography color={'text.secondary'}>
                      {item.date}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default LastStories;
